export enum AttachmentType {
    jpg = 'image/jpeg',
    jpeg = 'image/jpeg',
    png = 'image/png',
    pdf = 'application/pdf',
    xls = 'application/vnd.ms-excel',
    xlsx = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
}
